import { Clipboard } from '@capacitor/clipboard';
import { Share } from '@capacitor/share';
import React, { useContext, useState } from 'react';
import { AppContext } from '../AppContext';
import { GUESS_COUNT } from '../consts';
import { findDateDiff } from '../helpers';

const greenBox = '🟩';
const emptyRow = '⬛⬛⬛⬛⬛';
const whiteBox = '⬜';
const yellowBox = '🟨';

export const getScore = ({ guesses = [], words = [] }) => {
  const score = guesses.filter((x) => words.includes(x.join(''))).length;
  return `${score}/2`;
};

const Results = () => {
  const [copied, setCopied] = useState(false);
  const [{ guesses, wordOne, wordTwo, wordOneDone, wordTwoDone }] = useContext(AppContext);

  const getEmojisForRow = ({ word, guess = '', guesses, otherWord, index }) => {
    const correctGuessIndexOfWord = guesses.map((guess) => guess.join('')).indexOf(word);
    const correctGuessIndexOfOtherWord = guesses.map((guess) => guess.join('')).indexOf(otherWord);

    if (correctGuessIndexOfWord >= 0 && correctGuessIndexOfOtherWord >= 0) {
      if (index > correctGuessIndexOfWord && index > correctGuessIndexOfOtherWord) {
        return ' ';
      }
    }

    if (correctGuessIndexOfWord >= 0) {
      if (index > correctGuessIndexOfWord) {
        return emptyRow;
      }
    }

    const alreadyYellowShowedLetters = [];
    let rowText = '';

    new Array(5).fill(' ').forEach((_, i) => {
      const letter = guess[i];
      const isThisLetterGuessedInCorrectPosition = letter === word[i];

      let shouldShowThisLetterYellow = false;
      const isThisLetterExistsInTheWord = word.includes(letter);

      if (isThisLetterExistsInTheWord && !isThisLetterGuessedInCorrectPosition) {
        //
        const howManyTimesThisLetterInCorrectPositionGuessed = guess.filter((letterOfInput, indexOfInnerLoop) => {
          if (word[indexOfInnerLoop] === letterOfInput && letterOfInput === letter) return true;
          return false;
        }).length;

        const howManyTimesLetterExistsInWord = word.split('').filter((x) => x === letter).length;
        const howManyTimesThisLetterYellowShowedBefore = alreadyYellowShowedLetters.filter((x) => x === letter).length;

        shouldShowThisLetterYellow =
          howManyTimesLetterExistsInWord - howManyTimesThisLetterInCorrectPositionGuessed > howManyTimesThisLetterYellowShowedBefore;

        if (shouldShowThisLetterYellow) {
          alreadyYellowShowedLetters.push(letter);
        }
      }

      if (isThisLetterGuessedInCorrectPosition) {
        rowText = rowText + greenBox;
      } else if (shouldShowThisLetterYellow) {
        rowText = rowText + yellowBox;
      } else {
        rowText = rowText + whiteBox;
      }
    });

    return rowText;
  };

  const getCompleteResultAsText = (result) => {
    const score = getScore({ guesses, words: [wordOne, wordTwo] });
    return `Dordle Türkçe ${findDateDiff()} | ${score} \n\n${result}\n https://dordle-tr.netlify.app`;
  };

  const triggerCopy = () => {
    setCopied(true);
    setTimeout(() => {
      setCopied(false);
    }, 1500);
  };

  const getTextToShare = () => {
    let text = '';
    new Array(GUESS_COUNT).fill(null).forEach((_, i) => {
      const guess = guesses[i];

      const wordOneEmojis = getEmojisForRow({ word: wordOne, guess, guesses, otherWord: wordTwo, index: i });

      const wordTwoEmojis = getEmojisForRow({ word: wordTwo, guess, guesses, otherWord: wordOne, index: i });
      text = text + wordOneEmojis + ' ' + wordTwoEmojis + ' \n';
    });
    return getCompleteResultAsText(text);
  };

  const onShare = () => {
    const text = getTextToShare();
    const share = async () => {
      const writeToClipboard = async () => {
        triggerCopy();
        await Clipboard.write({
          string: text,
        });
      };

      const shareData = {
        text,
      };

      try {
        writeToClipboard();
        await Share.share(shareData);
      } catch (err) {
        if (window?.navigator?.userAgentData?.mobile) {
          try {
            await navigator.share(shareData);
          } catch (err) {
            console.log(err);
          }
        } else {
          window.navigator.clipboard.writeText(text);
          setCopied(true);
          setTimeout(() => {
            setCopied(false);
          }, 1500);
        }
      }
    };
    share();
  };
  const showShareButton = (wordOneDone && wordTwoDone) || guesses.length === GUESS_COUNT;
  return showShareButton ? (
    <div className='mt-4 w-full px-5'>
      <button
        onClick={onShare}
        className='bg-gradient-to-bl from-blue-400 via-sky-800 to-blue-600 hover:bg-gradient-to-tr font-semibold px-4 py-2 rounded text-lg text-white w-full'
      >
        {copied ? 'Kopyalandı' : 'Sonucu Paylaş'}
      </button>
    </div>
  ) : null;
};

export default Results;
